// extracted by mini-css-extract-plugin
export default {"iframe":"showIFrame_iframe__lyMzF"};